import { useEffect } from "react";
import { useFormValidator } from "../../../../../common/inputs/useFormValidator";
import { ValidatedTextInput } from "../../../../../common/inputs/ValidatedInputs";

const Comments = (props) => {
    const { data, handleInputChange, onChangeValid, loading } = props;
    const { comments } = data;

    const [valid, setValid] = useFormValidator();

    const onChange = (id, value, valid) => {
        handleInputChange([{
            id,
            value
        }]);

        setValid(id, valid);
    }

    useEffect(() => {
        onChangeValid && onChangeValid(valid)
    }, [onChangeValid, valid]);

    return <ValidatedTextInput
        margin="dense"
        id="comments"
        label="Comments"
        fullWidth
        multiline
        rows="2"
        onChange={onChange}
        disabled={loading}
        value={comments}
    />

}

export default Comments;